import { Component, OnInit } from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { InvalidFieldMessageService } from 'src/app/services/invalid-field-message/invalid-field-message.service';
import { ResetPasswordService } from 'src/app/services/reset-password/reset-password.service';
import * as Sentry from "@sentry/angular-ivy";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.page.html',
  styleUrls: ['./reset-password.page.scss'],
  providers: []
})
export class ResetPasswordPage implements OnInit{
  resetPasswordFormGroup: FormGroup;
  private key: string | undefined
  public loading: boolean = false;
  private specialCharacter = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  private uppercaseLetter = /[A-Z]/;
  constructor(private formBuilder: FormBuilder, private messageService: InvalidFieldMessageService, private authenticationService: AuthenticationService,
  private route: ActivatedRoute, private resetPasswordService: ResetPasswordService, private translateService: TranslateService, private snackBar: MatSnackBar) {
    this.authenticationService.verifyIfIsLogged();
    this.resetPasswordFormGroup  = this.formBuilder.group({
      password: ['', [Validators.required, Validators.maxLength(30), Validators.minLength(8), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)]],
      repeatedPassword: ['', [Validators.required, Validators.maxLength(30), Validators.minLength(8)]]
    }, {validator: this.checkPasswords});
  }

  ngOnInit(): void {
    this.key = this.route.snapshot.queryParams['key'];
  }

  get message() {
    return this.messageService
  }

  private checkPasswords: ValidatorFn = (group: AbstractControl):  ValidationErrors | null => { 
    let pass = group.get('password')?.value;
    let confirmPass = group.get('repeatedPassword')?.value
    if(pass === confirmPass) {
      group.get('repeatedPassword')?.value ? group.get('repeatedPassword')?.setErrors(null) : group.get('required')
    } else {
      group.get('repeatedPassword')?.setErrors({ notSame: true })
    }
    return null
  }

  get form()
  {
    return this.resetPasswordFormGroup.controls;
  }

  public async changePassword() {
    this.loading = true;
    try {
        if(this.resetPasswordFormGroup.valid) {
            await this.resetPasswordService.resetPassword({key: this.key!, password: this.form['password'].value})
            this.snackBar.open(this.translateService.instant("changePassword.success"), '', {
              duration: 10000,
              verticalPosition: 'top',
              panelClass: ['green-snackbar']
            });
        }
        this.loading = false;
    } catch(e: any) {
      this.loading = false;
      if (e?.statusCode == 400  && e?.data) {
        this.snackBar.open(e?.data, '', {
          duration: 10000,
          verticalPosition: 'top',
          panelClass: ['warning-snackbar']
        })
      } else if (e?.statusCode >= 500 && e?.statusCode <= 599 && e?.data) {
        this.snackBar.open(this.translateService.instant("changePassword.serverError"), '', {
          duration: 10000,
          verticalPosition: 'top',
          panelClass: ['red-snackbar']
        })
        this.logSentryResetPasswordError(e);
      } else {
        this.snackBar.open(this.translateService.instant("changePassword.unexpectedError"), '', {
          duration: 10000,
          verticalPosition: 'top',
          panelClass: ['red-snackbar']
        });
        this.logSentryResetPasswordError(e);
      }
    }
  }

  public justOneSpecialCharacter(event: KeyboardEvent, nomeCampo: string) {
    if (event.code.includes("Space") || event.key == "¨" || event.key == "´") {
      event.preventDefault();
      return;
    }
    if (this.specialCharacter.test(this.resetPasswordFormGroup.controls[nomeCampo].value)) {
      if (this.specialCharacter.test(String.fromCharCode(event.charCode))) {
        event.preventDefault();
      }
    }

    if (this.uppercaseLetter.test(this.resetPasswordFormGroup.controls[nomeCampo].value)) {
      if (this.uppercaseLetter.test(String.fromCharCode(event.charCode))) {
        event.preventDefault();
      }
    }
  }

  logSentryResetPasswordError(error: any) {
    const customError = new Error("Erro ao redefinir de senha da conta");
    (customError as any).cause = error;
    Sentry.captureException(customError);
  }
}